import React from "react";

const PriceIntersectsFirstCandleDocs = (
    <>
        <p>
            If the price intersects the low of the first candle of the day if long, or
            if the price intersects the high of the first candle of the day if short,
            cancel the setup.
        </p>
        <p>
            Ex: You have a bounce off ema setup for the 8 5 min ema. You believe that if
            price breaks the low of the 15min 9:30 candle, that you should not go long
            anymore, and cancel the setup. That is the goal of this filter.
        </p>
        params:
        <p>
            <b>candleDuration: </b> the duration of the first 9:30 candle that you would like to track.
        </p>
        <p>
            <b>Below, Above, High, Low:</b> configures what conditions must be met in terms of the candle to filter.
            For example, if the candleDuration is 2, Below is selected, and High is selected,
            we will only allow trades that occur when the current price is below open 2 minute candle High. If Low was
            selected instead of High,
            we will only allow trades below the candle low. If Above and High are selected, only trades above the 2
            min candle high will pass the filter. Lastly, if Above and Low are selected, only trades above 2 min candle
            low
            will pass.
        </p>
        <p>NOTE:</p>
        <p>
            We calculate hours by market open, 9:30 am. If you use another platform and have pre market on,
            you might end up having a different candle open time than us. For example, if you trade the hour charts and
            have premarket on on TOS, the hourly candle starts at 9:00 am, since they are calculating since 4 am. As of
            now, we are always starting from 9:30 am.
        </p>
    </>
);
export default PriceIntersectsFirstCandleDocs;
